import {
    AspectRatio,
    SkeletonText,
    SkeletonTextHeading,
    SkeletonTextLine,
    StandardTile,
    StandardTileContents,
    StandardTileImage,
    StandardTileName,
    StandardTilePrice,
} from '@vp/swan';
import { RECOMMENDATIONS_IMAGE_ASPECT_RATIO } from '../../lib';

export function RecommendationSkeletonTile() {
    return (
        <StandardTile>
            <StandardTileImage>
                <AspectRatio ratio={RECOMMENDATIONS_IMAGE_ASPECT_RATIO} loadingShimmer />
            </StandardTileImage>
            <StandardTileContents>
                <StandardTileName>
                    <SkeletonText>
                        <SkeletonTextHeading></SkeletonTextHeading>
                    </SkeletonText>
                </StandardTileName>
                <StandardTilePrice>
                    <SkeletonText>
                        <SkeletonTextLine width="narrow"></SkeletonTextLine>
                    </SkeletonText>
                </StandardTilePrice>
            </StandardTileContents>
        </StandardTile>
    );
}
